<div fxLayout="row" fxLayoutAlign="start center" mat-dialog-title>
  <h2 class="headline m-0" fxFlex="auto">{{displayName}}</h2>
  <button class="text-secondary" mat-icon-button type="button" (click)="onClose()">
    <mat-icon [icIcon]="icClose"></mat-icon>
  </button>
</div>
<mat-divider class="-mx-6 text-border"></mat-divider>
<div class="p-3">
  <vex-scrollbar [@stagger]="true" class="flex-auto" [ngStyle]="{'max-height': scrollHeight}">
    <table attr.id="{{name}}_tables" class="w-full mat-table resizable">
      <thead>
          <tr class="mat-header-row text-left">
            <th class="uppercase mat-header-cell sticky bg-white">#</th>
            <ng-container *ngFor="let type of columns">
              <ng-container *ngIf="type.DataGeneratedBy=='User' || (type.DataGeneratedBy=='CSP' && type.IsParentProperty == true)">
                <th class="uppercase mat-header-cell">
                  {{type.DisplayName}}
                </th>
              </ng-container>
            </ng-container>
          </tr>
      </thead>
      <tbody>
        <ng-container *ngIf="data && data.length > 0; else showNone">
          <ng-container *ngFor="let item of data;let i = index;let odd=odd;trackBy:trackByListId">
            <tr class="mat-row" [ngClass]="{'bg-row-color': odd}">
              <td class="mat-cell" [ngClass]="{'bg-row-color': odd, 'bg-white': !odd}">{{i+1}}</td>
              <ng-container *ngFor="let type of getRowAttribute(item);">
                <ng-container *ngIf="type.DataGeneratedBy=='User' || (type.DataGeneratedBy=='CSP' && type.IsParentProperty == true)">
                  <td style="cursor: pointer;" class="mat-cell word-break">
                    {{ getAttributeValue(item, type)}}
                  </td>
                </ng-container>
              </ng-container>
            </tr>
          </ng-container>
        </ng-container>
        <ng-template #showNone>
          <tr class="mat-row">
            <b>N/A</b>
          </tr>
        </ng-template>
      </tbody>
    </table>
  </vex-scrollbar>
</div>